import React, { useEffect, useContext }from "react";
import useForm from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import ReactTable from "react-table";

// ui components
import { makeStyles } from "@material-ui/core/styles";
import TextField from '@material-ui/core/TextField';
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import Select from 'react-select';
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Checkbox from "@material-ui/core/Checkbox";

//icons 
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Button from "beaktShared/components/CustomButtons/Button.js";
import SnackbarContent from "beaktShared/components/Snackbar/SnackbarContent.js";
import { noCaseSensitive } from 'beaktShared/helpers/extras';
import { SessionContext } from "beaktShared/services/session";

// services
import { UseGetApiSimple, UsePutApi, useGetApi, UsePostApi } from "beaktShared/services/crudeApiService";
import { MaskMoney, transformValueFormatedtoFloat, transformValueFloattoFormated, formateDate , formateDateandTime } from "beaktShared/helpers/masks";

// styles
import styles from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
const useStyles = makeStyles(styles);

export default function PagamentoEstabelecimento({item, CallHandleVoltar, CallUpdateItem}) {
  const { t } = useTranslation();
  const classes = useStyles();
  const session = useContext(SessionContext);

  const [notification, setNotification] = React.useState({
    show:false,
    color:'info',
    message:''
  });
  const showNotification = (message,color) => { 
      setNotification({
        show:true,
        color:color,
        message:message      
      });
      setTimeout(function() {
        setNotification({show:false});
      }, 8000);       
  };

  const { register, handleSubmit, setValue, errors, getValues, setError } = useForm({mode: "onChange"}); 
  const [loading, setLoading] = React.useState(false);

  const [controleCobranca, setcontroleCobranca] = React.useState(false)

  const [{list, isLoadingList, isErrorGetList}, setListAtualiza] = useGetApi("Estabelecimentos/getestabelecimentoProvisionamentosetuplog/" + item.estabelecimentoId);

  const [listSelectFormaPgtos, setlistSelectFormaPgtos] = React.useState([]);
  const [listSelectFormaPgtosSelected, setlistSelectFormaPgtosSelected] = React.useState([]);
  const [formapagamentos, setformapagamentos] = React.useState([]);
  const [loadingSelectFormaPgtos, setloadingSelectFormaPgtos] = React.useState(false);
  const loadFormasPagamento = () =>{   
    setloadingSelectFormaPgtos(true);     
      UseGetApiSimple("formaPagamentos/ativos/").then(result=>{      
          if(result.status !== 200)
          {                                     
              showNotification(t('error_message.payment_methods_could_not_be_loaded')+"!" ,'danger'); 
              setloadingSelectFormaPgtos(false); 
              return false; 
          }     
          setlistSelectFormaPgtos(result.data);  
          setloadingSelectFormaPgtos(false); 
          return true;                
      });  
  }
  const handleFormaPgtoChange = event => {
      let value = event
      let data = getValues()

      let lstsAdd = [];
      let lstSelect = [];
      value.map(item =>{
          lstsAdd.push(item.formaPagamentoId); 
          
          lstSelect.push({
              formaPagamentoId: item.formaPagamentoId,
              estabelecimentoId:data.estabelecimentoId
          });                   
      });
      setformapagamentos(lstsAdd); 
      setlistSelectFormaPgtosSelected(lstSelect);

  };

  const [habilitaSolicitacao, setHabilitaSolicitacao] = React.useState(false);

  useEffect(() => {
    loadFormasPagamento();
  }, []);

  useEffect(() => {
    if(!item.estabelecimentoId)
        return;       
    
    setValue("estabelecimentoId", item.estabelecimentoId);
    if(item.provisionamento)
      setValue("provisionamento", transformValueFloattoFormated(item.provisionamento));  
    if(item.percentualSplit != null)
      setValue("percentualSplit", transformValueFloattoFormated(item.percentualSplit));   

    setcontroleCobranca(item.controleCobranca);

    loadSelectFPView(item.estabelecimentoFormaPagamentos);

    if (session.id === 1)
    {
      setHabilitaSolicitacao(true);
      loadSolicitacao();
    }
    else
    {
      setHabilitaSolicitacao(false);
    }

  }, [item]);

  const loadSelectFPView = (estabelecimentoFormaPagamentos) =>{        
    if(estabelecimentoFormaPagamentos===null)
        return;

    setlistSelectFormaPgtosSelected(estabelecimentoFormaPagamentos);

    let lstAdd = [];
    estabelecimentoFormaPagamentos.map(item =>{
        lstAdd.push(item.formaPagamentoId);                 
    });        
    setformapagamentos(lstAdd); 
}

  const onSubmit = (data, e) => {   
    e.preventDefault();
    setLoading(true);  
    
    if(!item.estabelecimentoId)
    {
      showNotification(t('information_message.fill_in_the_details'),'danger');
      setLoading(false);  
      return false;
    }
    
    let provisionamento = null;
    if(data.provisionamento !== "")
      provisionamento = transformValueFormatedtoFloat(data.provisionamento);
    
    let percentualSplit = null;
    if(data.percentualSplit !== "")
      percentualSplit = transformValueFormatedtoFloat(data.percentualSplit);

    setcontroleCobranca(data.controleCobranca);

    let estabelecimento = {
      ...item,
      estabelecimentoId: item.estabelecimentoId,
      provisionamento: provisionamento,
      percentualSplit: percentualSplit,
      estabelecimentoFormaPagamentos: listSelectFormaPgtosSelected,
      controleCobranca: controleCobranca
    }

    setLoading(true);
    let endPoint = "estabelecimentos/atualizaformapgto/"
    UsePutApi(endPoint,estabelecimento.estabelecimentoId + "/" + session.id,estabelecimento).then(result=>{      
      if(result.status !== 200)
      {                                    
        showNotification(result.message,'danger');
        setLoading(false);
        return false; 
      } 
      CallUpdateItem(result.data);
      showNotification(result.message,'success');
      setLoading(false);
      return true;                 
    }); 

  }
  const columns = [
    {
      Header: t('label.user'),
      accessor: "usuario.nome",
    },
    {
        Header: t('label.date'),
        accessor: "dataAlteracao",
        Cell: (props) => <div> {props.value?formateDate(props.value):""} </div> 
    },
    {
        Header: "% "+t('label.split'),
        accessor: "percentualSplit",
    },
    {
        Header: t('accreditation.provisioning_value'),
        accessor: "valorProvisionamento",
        Cell: (props) => <div> {transformValueFloattoFormated(props.value?props.value:0)} </div> 
    }]    

  const endPoint = "estabelecimentoSolicitacao/";
  const [existeSolicitacao, setExiteSolicitacao] = React.useState(false);
  const [solicitacao, setSolicitacao] = React.useState([]);
  const loadSolicitacao = () => {
    setLoading(true);
    UseGetApiSimple(endPoint + "byestabelecimento/" + item.estabelecimentoId).then(result=> {
      if(result.status !== 200)
      {
        setLoading(false);
        setExiteSolicitacao(false);
        return false;
      }
      
      setExiteSolicitacao(false);

      if (result.data !== '')
      {
        setSolicitacao(result.data);
        setExiteSolicitacao(true);
      }
      
      setLoading(false);
    }); 
  }

  const [solicitacaoStatusOptions, setSolicitacaoStatusOptions] = React.useState([
    {text: "ACEITO", value: "1"},
    {text: "RECUSADO", value: "3"},
  ]);

  const [solictacaoStatusOptionsSelected, setSolictacaoStatusOptionsSelected] = React.useState("");
  const handleSolicitacaoStatusOptionsChange = (event) => {
      let value = event;
      setSolictacaoStatusOptionsSelected(value);
      setValue("situacaoStatus", value);
  }

  const handleClickConfirmaSolicitacaoStatus = () => {
    let data = getValues();

    if (data.situacaoStatus === "" || data.situacaoStatus === undefined)
    {
      setError("situacaoStatus","required", t('label.required'))
      return false;
    }

    if ((data.situacaoMotivo === "" || data.situacaoMotivo === undefined) &&
        (data.situacaoStatus === "3"))
    {
      setError("situacaoMotivo","required", t('label.required'))
      return false;
    }
    
    let enviaAnaliseSolictacao = {
      estabelecimentoSolicitacaoId: solicitacao.estabelecimentoSolicitacaoId,
      status: data.situacaoStatus,
      motivoRecusa: data.situacaoMotivo,
    }

    setLoading(true);
    UsePostApi(endPoint + "updateSolicitacao", enviaAnaliseSolictacao).then(result => {
      if(result.status !== 200)
      {                                    
        showNotification(result.message,'danger');
        setLoading(false);
        return false; 
      }
      
      showNotification(result.message,'success');
      setLoading(false);
      loadSolicitacao();
      return true;                 
    });
    
  }

  return (
    <div style={{width:'100%',padding:'20px'}}>
      <form onSubmit={handleSubmit(onSubmit)}>
        
        <input style={{display:'none'}} defaultValue={0} name="estabelecimentoId" ref={register} />

        <GridContainer>   
          <GridItem xs={12} sm={12} md={12}>
          <div className="subTitulo"> 
            <h6>{t('accreditation.enable_payment_methods')} </h6>
          </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>     
          <FormControl fullWidth className={classes.formControl}>  

            <label className={errors.estabelecimentos?"select__label select__label_error":"select__label"}>
              {t('label.forms_of_payment')} </label>
            <Select
                classNamePrefix="select"  
                isSearchable={true}
                placeholder={t('label.select')+"..."}
                isMulti={true}    
                name="formapagamentos"                                  
                isLoading={loadingSelectFormaPgtos}
                options={listSelectFormaPgtos}     
                getOptionLabel={({descricao}) => descricao}
                getOptionValue={({formaPagamentoId}) => formaPagamentoId} 
                value={listSelectFormaPgtos.filter(({formaPagamentoId}) => formapagamentos.indexOf(formaPagamentoId) != -1)}
                onChange={(value) => handleFormaPgtoChange(value || [])}                                      
                ref={() => register( { name: "formapagamentos" }) }
            />
            {errors.formapagamentos && <FormHelperText className={classes.labelRootError}>
              <span> {t('error_message.select_a_payment_method')} </span>
            </FormHelperText> } 
            </FormControl> 
          </GridItem> 
        </GridContainer>
        {
          habilitaSolicitacao && 
          (
            <>
              <div style={{ width: '100%', padding: '10px 0', color: '#443a3aa1' }}>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <div className="subTitulo" style={{ margin: "0px" }}>
                      <h6>{t('accreditation.integrated_pix_request')} </h6>
                    </div>
                  </GridItem>
                </GridContainer>
                {
                  existeSolicitacao ? (
                    solicitacao && (
                      <>
                        <hr style={{ border: '0rem', margin: '15px 0 0 0' }} />
                        <GridContainer>
                          <GridItem xs={12} sm={4} md={4}>
                              <span style={{ margin: '0' }}>Data de registro</span>
                              <h5 style={{ margin: '0', fontWeight: 'bold' }}>{formateDateandTime(solicitacao.dataRegistro)}</h5>
                          </GridItem>
                          <GridItem xs={12} sm={4} md={4}>
                              <span style={{ margin: '0' }}>Status</span>
                              <h5 style={{ margin: '0', fontWeight: 'bold' }}>{solicitacao.statusDescricao}</h5>
                          </GridItem>
                          <GridItem xs={12} sm={4} md={4}>
                            {solicitacao.status !== 2 && (
                              <>
                                <span style={{ margin: '0' }}>Data da análise</span>
                                <h5 style={{ margin: '0', fontWeight: 'bold' }}>{formateDateandTime(solicitacao.dataAnalise)}</h5>
                              </>
                            )}
                          </GridItem>
                        </GridContainer>
                        <hr style={{ border: '0.035rem solid #e8e4e4', margin: '15px 0' }} />
                        <GridContainer>
                          <GridItem xs={12} sm={4} md={4}>
                              <span style={{ margin: '0' }}>Nome</span>
                              <h5 style={{ margin: '0', fontWeight: 'bold' }}>{solicitacao.nome}</h5>
                          </GridItem>
                          <GridItem xs={12} sm={4} md={4}>
                              <span style={{ margin: '0' }}>Celular</span>
                              <h5 style={{ margin: '0', fontWeight: 'bold' }}>{solicitacao.celular}</h5>
                          </GridItem>
                          <GridItem xs={12} sm={4} md={4}>
                              <span style={{ margin: '0' }}>E-mail</span>
                              <h5 style={{ margin: '0', fontWeight: 'bold' }}>{solicitacao.email}</h5>
                          </GridItem>
                        </GridContainer>
                        {
                          solicitacao.status === 3 && (
                            <>
                              <hr style={{ border: '0.035rem solid #e8e4e4', margin: '15px 0' }} />
                              <GridContainer>
                                <GridItem xs={12} sm={12} md={12}>
                                  <span style={{ margin: '0' }}>Motivo</span>
                                  <h5 style={{ margin: '0', fontWeight: 'bold' }}>{solicitacao.motivoRecusa}</h5>
                                </GridItem>
                              </GridContainer>
                              <hr style={{ border: '0rem', margin: '15px 0' }} />
                            </>
                          )
                        }
                        {
                          solicitacao.status === 2 && (
                            <>
                              <hr style={{ border: '0.035rem solid #e8e4e4', margin: '15px 0' }} />
                              <GridContainer>
                                <GridItem xs={12} sm={4} md={4}>
                                  <FormControl fullWidth className={classes.formControl}>
                                    <label className={"select__label"}>{t('label.status')}</label>
                                    <Select
                                      //styles={ValidSelect(false)} 
                                      classNamePrefix="select"            
                                      isSearchable={true}
                                      name="situacaoStatus"
                                      placeholder={t('label.select')+"..."}
                                      options={solicitacaoStatusOptions} 
                                      value={solicitacaoStatusOptions.filter(({ value }) => value == solictacaoStatusOptionsSelected)}      
                                      getOptionLabel={({ text }) => text}
                                      getOptionValue={({ value }) => value}          
                                      onChange={(value) => handleSolicitacaoStatusOptionsChange(value.value)}
                                      ref={() => register( { name: "situacaoStatus" })}
                                    />
                                    {
                                      errors.situacaoStatus && 
                                      <FormHelperText className={classes.labelRootError}>
                                        <span>{t('label.required')}</span>
                                      </FormHelperText>
                                    }
                                  </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={8} md={8}>
                                  <FormControl fullWidth className={classes.formControl}>
                                    <TextField
                                        error={false}
                                        variant="outlined"
                                        inputRef={register({required: false})}
                                        label="Motivo do status"
                                        name="situacaoMotivo"
                                        InputLabelProps={{shrink: true}}     
                                        InputProps={{maxLength: 256}}
                                    />
                                    {
                                      errors.situacaoMotivo && 
                                      <FormHelperText className={classes.labelRootError}>
                                        <span>{t('label.required')}</span>
                                      </FormHelperText>
                                    }
                                  </FormControl>
                                </GridItem>
                              </GridContainer>
                              <hr style={{ border: '0.035rem solid #e8e4e4', margin: '15px 0' }} />
                              <GridContainer>
                                <GridItem xs={12} sm={12} md={12}>
                                  <Button round color="primary" 
                                    onClick={e => { handleClickConfirmaSolicitacaoStatus()}}
                                  >
                                      Confirma alteração do status 
                                  </Button>
                                </GridItem>
                              </GridContainer>
                            </>
                          )
                        }
                      </>
                    )
                  ) : (
                    <>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                          <FormControl fullWidth className={classes.formControl}>
                            <h4>Não existe solicitação de liberação de PIX integrado para o estabelecimento.</h4>
                          </FormControl>
                        </GridItem>
                      </GridContainer>
                    </>
                  )
                }
              </div>
            </>
          )
        }
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <div className="subTitulo" style={{ margin: "0px" }}>
                <h6>{t('accreditation.collection_control')} </h6>
              </div>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    tabIndex={-1}
                    checked={controleCobranca}
                    onClick={event => { setcontroleCobranca(event.target.checked) }}
                    name="controleCobranca"
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    classes={{ checked: classes.checked, root: classes.checkRoot }}
                    inputRef={register}
                  />
                }
                classes={{ label: classes.label, root: classes.labelRoot }}
                label={t('accreditation.enable_automatic_billing')}
              />
            </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
          <div className="subTitulo"> 
            <h6>{t('accreditation.payment_slipt')} </h6>
          </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <FormControl fullWidth className={classes.formControl}>
              <TextField
                  error={errors.percentualSplit?true:false}
                  label={t('accreditation.slipt_for_establishment')}
                  variant="outlined"
                  inputRef={register({ required: false })}
                  name="percentualSplit"
                  InputLabelProps={{shrink: true}}
                  inputProps={{maxLength: 10}}
                  InputProps={{ inputComponent: MaskMoney}} 
              />
              {errors.percentualSplit && <FormHelperText className={classes.labelRootError}>
                  <span>{t('accreditation.slipt_is_required')} </span>
              </FormHelperText>}
            </FormControl>
          </GridItem>
          <GridItem xs={12} sm={6} md={6}>
            <FormControl fullWidth className={classes.formControl}>
            <TextField
                error={errors.provisionamento?true:false}
                label={t('accreditation.provisioning_value')}
                variant="outlined"
                inputRef={register({required: false})}
                name="provisionamento"
                InputLabelProps={{shrink: true}}
                InputProps={{maxLength: 10, inputComponent: MaskMoney}}   
            />
            {errors.provisionamento && <FormHelperText className={classes.labelRootError}>
                <span>{t('label.required')} </span>
            </FormHelperText>}
            </FormControl>
        </GridItem> 
        </GridContainer>
        <GridContainer>
          <br/>
          <GridItem xs={12} sm={12} md={12}>
          <div className="subTitulo"> 
          <h6>{t('label.split_of_payment_change_history')} </h6>
          </div>
          </GridItem>
          <GridItem xs={12} sm={12} md={12}>
            <ReactTable
                loading = {isLoadingList}
                data={list}
                filterable
                defaultFilterMethod = {noCaseSensitive}
                columns={columns}
                defaultPageSize={10}
                minRows={5}
                showPaginationBottom={true}
                className="-striped -highlight"
                previousText={t('button.previous')}
                nextText={t('button.next')}
                loadingText={t('label.loading')+"..."}
                noDataText={t('information_message.no_records_found')+"!"}
                pageText={t('label.page')}
                ofText={t('label.of')}
                rowsText={t('label.rows')}
            />
          </GridItem>
        </GridContainer> 
        
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>  
          <center>  <br/><br/>  
          {notification.show &&
            <SnackbarContent
              message={notification.message}
              color={notification.color}
              closeNotification={() => setNotification({show:false})}
              close
            />}

            <Button onClick={() => CallHandleVoltar()} color="transparent" >
              {t('label.return')}
            </Button>
            <Button type="submit" color="primary" >
                {t('button.to_save')} 
                {loading && <div> ...{t('label.loading')} </div>}
            </Button>
            </center>  
          </GridItem>
        </GridContainer>  
      
      </form>
  </div>
  );
}